import { PaymentMethod } from "constants/methods";
import { Dispatch, SetStateAction, useState } from "react";
import { useForm } from "react-hook-form";
import { PaymentFormType, Step } from "./scheme";
import { PaymentStep } from "./PaymentStep";
import { ConfirmStep } from "./ConfirmStep";
import { CompletedStep } from "./CompletedStep";
import { PaymentResultModal } from "./PaymentResultModal";

interface PaymentDialogProps {
  paymentInUSD: number;
  paymentMethod: PaymentMethod;
  open: boolean;
  onOpenChange: (val: boolean) => void;
  referralCode: string;
  setIsPaymentDialogOpen: Dispatch<SetStateAction<boolean>>;
  promoCodePercentage: number;
}

export function PaymentDialog({
  paymentInUSD,
  open,
  onOpenChange,
  paymentMethod,
  setIsPaymentDialogOpen,
  referralCode,
  promoCodePercentage,
}: PaymentDialogProps) {
  const [actualPaymentAmount, setActualPaymentAmount] = useState(0);
  const [isPymentModalOpened, setIsPymentModalOpened] = useState(false);
  const [isSucces, setIsSucces] = useState(false);

  const form = useForm<PaymentFormType>({
    defaultValues: {
      step: Step.Confirm,
      paymentMethod: paymentMethod,
      paymentStatus: "WAITING_PAYMENT",
      payAmount: 0,
      payAddress: "",
      referral: "",
    },
  });

  const step = form.watch("step");

  const address = form.watch("payAddress");

  const handleChangeStep = (step: Step) => {
    form.setValue("step", step);
  };
  return (
    <div>
      <div>
        {step === Step.Confirm && (
          <ConfirmStep
            paymentInUSD={paymentInUSD}
            preselectedMethod={paymentMethod}
            setIsPaymentDialogOpen={setIsPaymentDialogOpen}
            referralCode={referralCode}
            handleChangeStep={handleChangeStep}
            promoCodePercentage={promoCodePercentage}
          />
        )}

        {step === Step.Payment && (
          <PaymentStep
            paymentInUSD={paymentInUSD}
            preselectedMethod={paymentMethod}
            setIsPaymentDialogOpen={setIsPaymentDialogOpen}
            referralCode={referralCode}
            handleChangeStep={handleChangeStep}
            setActualPaymentAmount={setActualPaymentAmount}
            actualPaymentAmount={actualPaymentAmount}
            setIsPymentModalOpened={setIsPymentModalOpened}
            setIsSucces={setIsSucces}
          />
        )}

        {step === Step.Completed && (
          <CompletedStep
            paymentInUSD={paymentInUSD}
            preselectedMethod={paymentMethod}
            setIsPaymentDialogOpen={setIsPaymentDialogOpen}
            referralCode={referralCode}
            handleChangeStep={handleChangeStep}
            actualPaymentAmount={actualPaymentAmount}
          />
        )}

        <PaymentResultModal
          isOpen={isPymentModalOpened}
          onOpenChange={() => {
            setIsPymentModalOpened(!isPymentModalOpened);
          }}
          isSuccess={isSucces}
          amount={actualPaymentAmount}
          currency={paymentMethod.currency}
          walletAddress={address}
          paymentMethod={paymentMethod}
        />
      </div>
    </div>
  );
}
